function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from "react";
import { UnstyledIcon } from "../icon";
import renderType from "./renderType";
import EventManager from "../commercePlatform/vanilla/utils/EventManager/EventManager";
import classnames from "classnames";

export var SpsGrowlerArea = function (_Component) {
  _inherits(SpsGrowlerArea, _Component);

  function SpsGrowlerArea() {
    var _temp, _this, _ret;

    _classCallCheck(this, SpsGrowlerArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      growlerList: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //TODO: Need to handle fade
  SpsGrowlerArea.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    EventManager.on("GROWLER.SHOW", function (growler) {
      if (!growler.fade || !isNaN(parseInt(growler.timeoutDuration))) {
        var growlers = _this2.state.growlerList.concat([growler]);
        _this2.setState({
          growlerList: growlers
        });
      } else {
        console.error("Failed prop type: Invalid type for timeoutDuration,  please provide a number for timeoutDuration");
      }
    });
    EventManager.on("GROWLER.HIDE", function (growler) {
      var growlerList = _this2.state.growlerList.filter(function (item) {
        return item.id !== growler.id;
      });
      _this2.setState({
        growlerList: growlerList
      });
    });
  };

  SpsGrowlerArea.prototype.render = function render() {
    return React.createElement(
      "div",
      { className: "sps-growler-area" },
      this.state.growlerList.map(function (growler) {
        return React.createElement(SpsGrowler, { visible: true, key: growler.id, opts: growler });
      })
    );
  };

  return SpsGrowlerArea;
}(Component);

var fadeTimeout = void 0;

export var SpsGrowler = function (_Component2) {
  _inherits(SpsGrowler, _Component2);

  function SpsGrowler() {
    var _temp2, _this3, _ret2;

    _classCallCheck(this, SpsGrowler);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this3), _this3.state = {
      iconClass: "",
      hovered: false
    }, _this3.stopCloseOnMouseEnter = function () {
      clearTimeout(fadeTimeout);
      _this3.setState({ hovered: true });
    }, _this3.releaseCloseOnMouseLeave = function () {
      _this3.setState({ hovered: false });
    }, _this3.onCloseHandler = function (event) {
      event.stopPropagation();

      if (_this3.props.opts.onClose) {
        clearTimeout(fadeTimeout);
        _this3.props.opts.onClose(_this3.props.opts);
      }
      EventManager.emit("GROWLER.HIDE", _this3.props.opts);
    }, _this3.autoCloseHandler = function () {
      if (!_this3.state.hovered) {
        if (_this3.props.opts.onClose) {
          clearTimeout(fadeTimeout);
          _this3.props.opts.onClose(_this3.props.opts);
        }
        EventManager.emit("GROWLER.HIDE", _this3.props.opts);
      }
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  SpsGrowler.prototype.render = function render() {
    var _this4 = this;

    var opts = this.props.opts;

    var iconClasses = {
      success: "sps-icon sps-icon-checkmark",
      error: "sps-icon sps-icon-exclamation-circle",
      warning: "sps-icon sps-icon-exclamation-triangle",
      info: "sps-icon sps-icon-info-circle",
      pending: "sps-spinner",
      default: "sps-icon sps-icon-info-circle"
    };
    var growlerClasses = classnames("sps-growler sps-growler--" + opts.preset + " show", {
      "fade": opts.fade && !this.state.hovered
    });
    // TODO: There `is` likely a more elegant way to sync the fade animation
    // and the removal of the growler from the container
    // Timeout for CSS fade animation
    var fadeTimeoutDuration = opts.timeoutDuration / 1000 || '7';
    // Timeout for removing the growler from the growler area
    var removeTimeoutDuration = opts.timeoutDuration || '7000';
    var growlerIcon = void 0;
    var iconClass = iconClasses[opts.preset];
    if (opts.fade && !this.state.hovered) {
      fadeTimeout = setTimeout(function () {
        _this4.autoCloseHandler();
      }, removeTimeoutDuration);
    }
    if (opts.icon) {
      iconClass = opts.icon === "string" && iconClasses[opts.icon] ? iconClasses[opts.icon] : opts.icon;
      growlerIcon = renderType(opts.icon) ? renderType(opts.icon) : function () {
        return React.createElement(UnstyledIcon, { className: iconClass });
      };
    } else {
      growlerIcon = function growlerIcon() {
        return React.createElement(UnstyledIcon, { className: iconClass });
      };
    }

    return React.createElement(
      Fragment,
      null,
      React.createElement(
        "style",
        null,
        "\n                .sps-growler.show {\n                    opacity: 1;\n                }\n                .sps-growler.show.fade {\n                    opacity: 0;\n                    animation-name: fadeOut;\n                    animation-iteration-count: 1;\n                    animation-timing-function: ease-in;\n                    animation-duration: " + fadeTimeoutDuration + "s;\n                }\n\n                @keyframes fadeOut {\n                    0% {\n                        opacity: 1;\n                    }\n                    95% {\n                        opacity: 1;\n                    }\n                    100% {\n                        opacity: 0;\n                    }\n                }\n            "
      ),
      React.createElement(
        "div",
        { className: growlerClasses, onMouseEnter: this.stopCloseOnMouseEnter, onMouseLeave: this.releaseCloseOnMouseLeave },
        React.createElement(
          "div",
          { className: "sps-growler__icon-box" },
          growlerIcon()
        ),
        React.createElement(
          "div",
          { className: "sps-growler__message-box" },
          React.createElement(
            "div",
            { className: "sps-growler__message-box-text" },
            React.createElement(
              "div",
              { className: "sps-growler__message-box-title" },
              opts.title
            ),
            React.createElement(
              "div",
              { className: "sps-growler__message-box-subtitle" },
              opts.msg
            )
          ),
          React.createElement(
            "button",
            {
              type: "button",
              className: "sps-growler__close-button",
              "aria-label": "Close panel",
              onClick: this.onCloseHandler
            },
            React.createElement("i", {
              className: "sps-icon sps-icon-x",
              "aria-hidden": "true",
              title: "Close the " + opts.preset + " message?"
            })
          )
        )
      )
    );
  };

  SpsGrowler.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(fadeTimeout);
  };

  return SpsGrowler;
}(Component);